/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export const UP_ARROW: number = 38;
export const DOWN_ARROW: number = 40;
export const RIGHT_ARROW: number = 39;
export const LEFT_ARROW: number = 37;
export const ENTER: number = 13;
export const SPACE: number = 32;
export const TAB: number = 9;
export const ESC: number = 27;
